import * as Highcharts from 'highcharts';
import * as jQuery from 'jquery';
import * as _ from 'underscore';

import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { UtilityService } from '../../../../core/utility/services/utility.service';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { ChartComponent } from '../chart/chart.component';

@Component({
	selector: 'app-chart-v3',
	styleUrls: ['./chart-v3.component.css'],
	templateUrl: './chart-v3.component.html'
})
export class ChartV3Component extends ChartComponent implements OnInit, OnDestroy {
	@Input() svgWidth;
	@Input() svgHeight;
	@Input() barChartConfiguration;

	public displayLiftData: any = [];

	constructor(protected colorUtilityService: ColorUtilityService, protected analyticsDataModel: AnalyticsDataModel) {
		super(colorUtilityService, analyticsDataModel);
	}

	ngOnInit(): void {}

	ngOnDestroy(): void {
		super.ngOnDestroy();
	}

	renderChart(chartData: any): void {
		// tslint:disable-next-line: no-this-assignment
		const self = this;
		this.displayLiftData = [];
		if (!_.isEmpty(this.barChartConfiguration)) {
			if (
				this.barChartConfiguration &&
				this.barChartConfiguration.stackLabels &&
				this.barChartConfiguration.stackLabels.enabled
			) {
				for (const data of chartData.graphData[0].data) {
					this.displayLiftData.push(data.lift.displayLift);
				}
			}
		}
		this.chartObj = new Highcharts.Chart({
			chart: {
				height: this.svgHeight || 500,
				marginBottom: this.barChartConfiguration.marginBottom,
				renderTo: this.chartElement.nativeElement,
				type: this.barChartConfiguration.type,
				width: this.svgWidth
			},
			legend: this.barChartConfiguration.legend,
			plotOptions: {
				column: this.barChartConfiguration.column,
				series: this.barChartConfiguration.series
			},
			series: chartData.graphData,
			subtitle: chartData.subtitle,
			title: chartData.title,
			tooltip: {
				backgroundColor: '#FFFFFF',
				borderColor: '#e5e5e5',
				borderWidth: 1,
				enabled: this.barChartConfiguration.tooltip.enabled,
				shared: true,
				style: {
					color: this.colorUtilityService.getHEXByColorType(this.analyticsDataModel.partner.colorPalette, 'primary', 1)
				},
				formatter(): any {
					let result = '';
					// tslint:disable-next-line: typedef
					jQuery.each(this.points, function (i: any, datum: any) {
						if (i === 0) {
							const displayLift = datum.point.lift.displayLift;
							result += `<b>${displayLift}X</b> Lift<br/>`;
						}
						const color = this.series.color;
						result += `<span style="color: ${color}"><b>${self.checkForNullTooltipValue(
							this.y
						)}%</b></span> <span style="color: ${color}"> ${this.series.name}</span><br/>`;
					});
					return result;
				},
				positioner(labelWidth: any, labelHeight: any, point: any): any {
					let tooltipX;
					let tooltipY;
					if (point.plotX + labelWidth > this.chart.plotWidth) {
						tooltipX = point.plotX + this.chart.plotLeft - labelWidth - 20;
					} else {
						tooltipX = point.plotX + this.chart.plotLeft;
					}
					tooltipY = point.plotY + this.chart.plotTop - 10;
					console.log(point, tooltipX, tooltipY)
					return { x: tooltipX, y: tooltipY };
				}
			},
			xAxis: [
				{
					categories: chartData && chartData.xAxis && chartData.xAxis.categories ? chartData.xAxis.categories : [],
					labels: chartData.xAxis.labels,
					lineColor: 'transparent',
					lineWidth: 0,
					minorGridLineWidth: 0,
					minorTickLength: 0,
					tickLength: 0,
					title: {
						text: null
					}
				}
			],
			yAxis: [
				{
					// Secondary yAxis
					gridLineColor: 'transparent',
					labels: {
						style: { fontSize: '14px' },
						formatter(): string {
							return this.value + '%';
						}
					},
					lineColor: 'transparent',
					lineWidth: 0,
					min: 0,
					minorGridLineWidth: 0,
					stackLabels: {
						// liftData: displayLiftData,
						align: this.barChartConfiguration.stackLabels.align,
						enabled: this.barChartConfiguration.stackLabels.enabled,
						style: {
							color: this.colorUtilityService.getHEXByColorType(
								this.analyticsDataModel.partner.colorPalette,
								'secondary',
								1
							)
						},
						formatter(): string {
							return `${self.getLiftValueForTooltip(this.x)}x Lift`;
						},
						x: -5
					},
					title: {
						text: null
					}
				}
			]
		});
		jQuery('.highcharts-series rect').css({ transform: 'translateY(-5px)' });
		jQuery('.highcharts-title').css({
			'border-radius': this.barChartConfiguration.title.borderRadius,
			padding: this.barChartConfiguration.title.padding,
			width: this.barChartConfiguration.title.width
		});
		jQuery('.highcharts-subtitle').css({
			'border-radius': this.barChartConfiguration.subtitle.borderRadius,
			padding: this.barChartConfiguration.subtitle.padding,
			width: this.barChartConfiguration.subtitle.width
		});
	}
	checkForNullTooltipValue(value: any): string | number {
		if (UtilityService.isUndefinedOrNull(value) || value === 0) {
			return '&lt;0.01';
		}
		return value;
	}

	getLiftValueForTooltip(xValue: any): string | number {
		return this.displayLiftData[xValue];
	}
}
